import { Box } from '@mui/material'
import { HEIGHT_COMPONENTS } from 'constants/ui.contants'
import theme, { color } from 'theme'
import BreadcrumbsDynamicCC from './BreadcrumbsDynamicCC'

/**
 * Breadcrumb cho ứng dụng
 * @param {*} param0 
 * @returns 
 */
const BreadcrumbsCC = ({ children, sxBreadcrumbsCC, namePackage }) => {

    return (
        <Box component={'div'} id='bread-crumbs' 
            sx={{ 
                minHeight: '48px', 
                height: {xs: HEIGHT_COMPONENTS.BREADCRUM_MOBILE, sm: HEIGHT_COMPONENTS.BREADCRUM}, 
                position: 'sticky',
                zIndex: 9,
                top: 0,
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                padding: `0 ${theme.spacing(2.5)} 0 ${theme.spacing(2)}`, 
                boxShadow: `0 1px ${color.boxShadow}`, 
                backgroundColor: 'white', 
                ...sxBreadcrumbsCC}}>
            <BreadcrumbsDynamicCC namePackage={namePackage} />
            {children}
        </Box>
    )
}

export default BreadcrumbsCC                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                